import {
  PUBLIC_METADATA,
  PublicPageMetadata,
} from '@lib/types/public-metadata';

import { formatDocumentTitle } from './document-title';

export const applyPublicPageMetadata = (metadata: PublicPageMetadata) => {
  document.title = metadata.title;
  const values = [
    ['name', 'description', metadata.description],
    ['property', 'og:title', metadata.title],
    ['property', 'og:description', metadata.description],
    ['property', 'og:url', metadata.canonicalUrl],
    ['property', 'og:type', 'website'],
    ['property', 'og:image', metadata.image],
    ['property', 'og:image:alt', metadata.title],
    ['name', 'twitter:card', 'summary_large_image'],
    ['name', 'twitter:title', metadata.title],
    ['name', 'twitter:description', metadata.description],
    ['name', 'twitter:image', metadata.image],
  ];

  values.forEach(([attribute, name, content]) => {
    const matches = document.querySelectorAll<HTMLMetaElement>(
      `meta[${attribute}="${name}"]`,
    );

    const meta = matches[0] ?? document.createElement('meta');
    matches.forEach((duplicate, index) => {
      if (index) {
        duplicate.remove();
      }
    });
    meta.setAttribute(attribute, name);
    meta.content = content;
    if (!meta.isConnected) {
      document.head.append(meta);
    }
  });
  const links = document.querySelectorAll<HTMLLinkElement>(
    'link[rel="canonical"]',
  );

  const link = links[0] ?? document.createElement('link');
  links.forEach((duplicate, index) => {
    if (index) {
      duplicate.remove();
    }
  });
  link.rel = 'canonical';
  link.href = metadata.canonicalUrl;
  if (!link.isConnected) {
    document.head.append(link);
  }
};

export const applyPageMetadata = (
  title?: string,
  pathname = window.location.pathname,
  description: string = PUBLIC_METADATA.DESCRIPTION,
  image?: string,
) => {
  const canonical = new URL(pathname, PUBLIC_METADATA.ORIGIN);
  canonical.search = '';
  canonical.hash = '';
  applyPublicPageMetadata({
    title: formatDocumentTitle(title),
    description,
    image:
      image ??
      new URL(PUBLIC_METADATA.DEFAULT_IMAGE, PUBLIC_METADATA.ORIGIN).href,
    canonicalUrl: canonical.href,
  });
};
